export interface ProcessorOption {
  value: string;
  label: string;
}

export const PROCESSOR_OPTIONS: ProcessorOption[] = [
  {
    label: 'North',
    value: 'North',
  },
  {
    label: 'Payblox',
    value: 'Payblox',
  },
];

export const getProcessorLabel = (value: string): string => {
  const processor = PROCESSOR_OPTIONS.find((p) => p.value === value);
  return processor?.label || value;
};

export default PROCESSOR_OPTIONS;
